import React, {useState} from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./scss/index.css";
import "./scss/vcTrustFramework.css"

import AboutUs from "./Components/Pages/AboutUs/AboutUs";
import News from "./Components/Pages/News/News";
import MyNextIdApp from "./Components/Pages/MynextId/MyNextIdApp";
import NewsArticle from "./Components/Pages/News/NewsArticle";
import VerifierApp from "./Components/Pages/Verifier/VerifierApp";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./Components/Pages/TermsOfService/TermsOfService";
import DppApp from "./Components/Pages/Dpp/DppApp";
import VcTrustFramework from "./Components/Pages/VcTrustFramework/VcTrustFramework";

function App() {
  
  // const VerifierApp = React.lazy(() => import("./Components/Pages/Verifier/VerifierApp"))

  return (
    <BrowserRouter>
        <Routes>
            <Route path="*" element={<MyNextIdApp/>} />
            <Route path="/verifier" element={<VerifierApp/>} />
            <Route path="/dpp" element={<DppApp/>} />
            <Route path="/about-us" element={<AboutUs/>} />
            <Route path="/news" element={<News/>} />
            <Route path="/news/:id" element={<NewsArticle/>} />
            
            <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
            <Route path="/terms-of-service" element={<TermsOfService/>} />


            {/* VC TRUST FRAMEWORK */}
            <Route path="/vc-apps" element={<VcTrustFramework/>} />

        </Routes>
    </BrowserRouter>
  );
}

export default App;
